<template>
    <form ref="form" :action="action" @submit.prevent.once="showConfirmBox" :method="formMethod">
        <input type="hidden" name="_method" :value="fieldMethod" v-if="fieldMethod"/>
        <csrf></csrf>
        <b-button :class="this.buttonClass" type="submit">
            <slot name="button">{{$t('buttons.general.crud.delete')}}</slot>
        </b-button>
        <slot></slot>
    </form>
</template>

<script>
    export default {
        props: {
            'action': {
                type: String,
                required: true
            },
            'method': {
                type: String,
                default: 'POST'
            },
            'message': {
                type: String,
            },
            'title': {
                type: String,
            },
            'okTitle': {
                type: String,
            },
            'cancelTitle': {
                type: String,
            },
            'buttonClass': {
                type: String
            }
        },
        data: function () {
            return {
            }
        },
        methods: {
            showConfirmBox() {
                let options = {
                    title: this.title ? this.title : this.$t('strings.general.dialog.confirm.title'),
                    okVariant: 'danger',
                    okTitle: this.okTitle ? this.okTitle : this.$t('buttons.general.continue'),
                    cancelTitle: this.cancelTitle ? this.cancelTitle : this.$t('buttons.general.cancel'),
                    hideHeaderClose: false,
                    centered: true
                };

                let message = this.message ? this.message : this.$t('strings.general.dialog.confirm.message');

                let boxFuture = this.$bvModal.msgBoxConfirm(message, options);

                if (boxFuture) {
                    boxFuture.then(value => {
                        if (value) {
                            this.$log.debug("Submit form", value)
                            this.$refs.form.submit();
                        } else {
                            this.$log.debug("MsgBox not confirmed", value)
                        }
                    }).catch(err => {
                        // An error occurred
                        this.$log.error("Error showing confirmation box", err)
                    });
                }
                return false;
            },
            formMethod: function () {
                if (this.method.toUpperCase() === 'GET') {
                    return 'GET';
                }
                return 'POST';
            },
            fieldMethod: function () {
                switch (this.method.toUpperCase()) {
                    case 'POST':
                    case 'GET':
                        return null;
                    default:
                        return this.method.toUpperCase();
                }
            }
        }
    }
</script>
